module.exports = __webpack_public_path__ + "media/Images/icon-star-cup-o-e4be6105dc3290abd4423f9596a4dce0.svg";